

function inputFile() {
    $( document ).ajaxComplete(function( event, request, settings ) {
        init();
    });
    init();

    $(document).on('submit', 'form[ajax-form-file]', function (e) {
        e.preventDefault();
        const container = $(e.target).parent();
        let formData = new FormData(this);
        const id = $(this).closest('form').prop('id');
        formData = $.customFile.addInputFile('#' + id, formData);

        if ($(this).find('[type="submit"]').hasClass('disabled')) return;
        $(container).addClass('loading');
        $(container).find('.form-error').html('').removeClass("in");
        $(container).find('.form-success').html('').removeClass("in");
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: formData,
            processData: false,
            contentType: false,
        })
            .done(function (data) {
                $(container).removeClass('loading');
                if (typeof data.form !== 'undefined') {
                    container.html(data.form);
                }
                if ((typeof data.url !== 'undefined') && (data.url !== null) && (data.url !== '')) {
                    var delay = 0;
                    if ((typeof data.urlDelay !== 'undefined') && (data.urlDelay !== null) && (data.urlDelay !== '')) {
                        delay = data.urlDelay;
                    }
                    setTimeout(function () {
                        window.location.replace(data.url);
                    }, delay);

                } else
                if ((typeof data.change !== 'undefined') && (data.change === 1)) {
                    window.location.reload();
                }
                if ((typeof data.disabled !== 'undefined') && (data.disabled === 1)) {
                    $(container).find('[type="submit"]').addClass('disabled');
                }
                if ((typeof data.msgko !== 'undefined')) {
                    $(container).find('.form-error').html(data.msgko);
                    if (data.msgko === '')
                        $(container).find('.form-error').removeClass('in');
                    else
                        $(container).find('.form-error').addClass('in');
                }
                if ((typeof data.msgok !== 'undefined')) {
                    $(container).find('.form-success').html(data.msgok);
                    if (data.msgok === '')
                        $(container).find('.form-success').removeClass('in');
                    else
                        $(container).find('.form-success').addClass('in');
                }
                if ((typeof data.replaceId !== 'undefined') && (data.replaceId !== '')) {
                    if ((typeof data.replaceContent !== 'undefined') && (data.replaceContent !== '')) {
                        $(data.replaceId).replaceWith(data.replaceContent);
                    }
                }
                if ((typeof data.autoclose !== 'undefined')) {
                    setTimeout(function () {
                        container.closest(".modal").modal('hide');
                    }, data.autoclose);
                }
                if ((typeof data.scrollTo !== 'undefined') && (data.scrollTo !== '')) {
                    $('html, body').animate({
                        scrollTop: $(data.scrollTo).offset().top
                    }, 750);
                }
                if ((typeof data.callback !== 'undefined') && (data.callback !== '')) {

                    var function_name = ""+data.callback;
                    if (function_name=='afterAdPopup') afterAdPopup();
                }
            })
            .fail(function (/* jqXHR, textStatus, errorThrown */) {
                $(container).removeClass('loading');
            });
    });



    $(document).on('click22','.input-file-button[type="submit"]', function(e) {
        e.preventDefault();

        const container = $($(this).closest('form')).parent();
        var id = $(this).closest('form').prop('id');
        console.log(id);
        console.log($.customFile.serialize('#' + id));


        //elements = (arguments.length>0)? arguments : [$('form')]; //Default all forms
    })
}


function init() {
    $('.inputfile').each(function () {
        const $field = $(this);

        const initialized = $field.data('initialized');
        const initializing = $field.data('initializing');

        if (!initialized && !initializing) {
            $field.data('initializing', true);

            $($field).customFile({
                allowed : ["xlsx","xls","jpg", "jpeg", "png", "bmp","doc","docx","ppt","pptx","txt","pdf"],
                messages : {
                    errorType : "Type de fichier non autorisé",
                    errorMaxMB : "Total weight exceeded",
                    errorFileKB : "Fichier trop gros",
                    errorMaxFiles : "Maximum number of files reached",
                    errorBigImage : "Image too big",
                    errorSmallImage : "Image too small",
                    errorOnReading : "App busy. Please, try again later.",
                    errorMultipleDisable : "Drag & drop one file at a time."
                },
                filePicker	: '<h3>Glissez vos fichiers ici</h3><p>ou cliquez pour les sélectionner</p><div class="cif-icon-picker"></div>',//markup or jQuery object. E.g $('#my-element')
            });

            $field.data('initialized', true);
            $field.data('initializing', false);
        }
    });
}



export default inputFile;
